/* eslint-disable max-len */
/**
 * Dependencies.
 */
import { RouteConfig } from 'vue-router';

import { AUTH_ROLES } from '@/constants/roles.constant';
import { ROUTES } from '@/constants/routes.constant';

/**
 * Export.
 */
export default [
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/counterparts${window.location.search}`;
    // },
    component: () =>
      import(
        /* webpackChunkName: "partner" */ '@/modules/counterparts/scenes/counterparts-list/counterparts-list.scene.vue'
      ),
    meta: { requiresAuth: true, roles: [AUTH_ROLES.PARTNERSHIP_USER] },
    name: ROUTES.COUNTERPARTS.COUNTERPARTS_LIST,
    path: 'partner/counterparts/list'
  },
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/counterparts${window.location.search}`;
    // },
    component: () =>
      import(
        /* webpackChunkName: "partner" */ '@/modules/counterparts/scenes/counterparts-detail/counterparts-detail.scene.vue'
      ),
    meta: { requiresAuth: true, roles: [AUTH_ROLES.PARTNERSHIP_USER] },
    name: ROUTES.COUNTERPARTS.COUNTERPART_DETAIL,
    path: 'partner/counterparts/detail'
  },
  {
    // beforeEnter: () => {
    //   window.location.href = `/apps/partner/counterparts${window.location.search}`;
    // },
    component: () =>
      import(
        /* webpackChunkName: "partner" */ '@/modules/counterparts/scenes/counterparts-detail-submit/counterparts-detail-submit.scene.vue'
      ),
    meta: { requiresAuth: true, roles: [AUTH_ROLES.PARTNERSHIP_USER] },
    name: ROUTES.COUNTERPARTS.COUNTERPART_DETAIL_SUBMIT,
    path: 'partner/counterparts/detail/:counterpartDetailId/submit'
  }
] as RouteConfig[];
